import React, { useEffect, useState, useRef } from "react";
import { bool, shape, string } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import { Col } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";

import * as i18nUtils from "util/i18n";
import { validateEmailWithRegex } from "util/form";
import { goBack, push } from "connected-react-router";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { selectors as modalselectors, actions as modalActions } from "reducers/modal";
import { selectors as alertselectors, actions as alertActions } from "reducers/alert";
import * as configUtils from "util/config";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import InfoModal from "../_components/InfoModal";
import ErrorPopup from "../_components/ErrorPopup";
import Stepper from "../_components/Stepper";

const FORM_ID = "onboarding.step.verifyEmail";

const StepEmail = ({
    isMobile,
    displayModal,
    displayAlert,
    verifyCode,
    exchangeToken,
    business,
    onboardingWithEnrolledUser,
}) => {
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [title, settitle] = useState("");
    const [error, setError] = useState("");
    const [error2, setError2] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [resendAvailable, setResendAvailable] = useState(true);
    const [validateError, setvalidateError] = useState(false);
    const TIME_TO_SEND_OTHER_CODE = configUtils.get("validation_code.retry.duration", 1) * 60000 || 60000;

    const timerRef = useRef(null);

    const [pageId, setPageId] = useState("StepEmail");

    useEffect(() => {
        if (onboardingWithEnrolledUser) {
            setPageId("StepEmailEnrolledUser");
        }
    }, [onboardingWithEnrolledUser]);

    useEffect(() => {
        if (isValidating && verifyCode?.status !== "OK" && verifyCode?.status !== "") {
            setvalidateError(true);
            setIsValidating(false);
            if (verifyCode?.data?.code === "API509W") {
                settitle("Alcanzastes el límite máximo de tiempo");
                setError("Has alcanzado el máximo de tiempo del ingreso de código de seguridad.");
                setError2("Por favor, vuelva a reintentarlo.");
                return;
            }
            settitle("No pudimos validar tu email");
            setError("Se produjo un error al validar el proceso. Por favor, intente nuevamente.");
            // dispatch(alertActions.alertShow());
        } else if (isValidating && verifyCode?.status === "OK") {
            setIsValidating(false);
            if (verifyCode?.type === "send") {
                dispatch(modalActions.modalShow());
            } else if (verifyCode?.type === "receive") {
                dispatch(modalActions.modalClose());
                dispatch(push("/onboarding/stepEmailSuccess"));
            }
        }
    }, [isValidating, verifyCode]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onFocus = (id, value) => {
        if (value === "") {
            return;
        }
        if (document.getElementById(id)) {
            document.getElementById(id).focus();
        }
    };
    const onFocusDown = (id, code, idLast, setFieldValue, value) => {
        if (code === "Backspace" && value === "") {
            if (document.getElementById(id)) {
                document.getElementById(id).focus();
            }
            if (idLast) {
                setFieldValue(idLast, "");
            }
        }
    };

    const sendCode = (emailToSend, shouldDisableBtn) => {
        setIsValidating(true);
        dispatch(onboardingActions.verifyCodeSend("email", emailToSend || email, "", "", business.name));
        if (shouldDisableBtn) {
            setResendAvailable(false);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setResendAvailable(true);
            }, TIME_TO_SEND_OTHER_CODE);
        }
    };

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            email: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                email: Yup.string()
                    .email(i18nUtils.get("onboarding.step.verifyEmail.email.error.invalidFormat"))
                    .required(i18nUtils.get("onboarding.step.verifyEmail.email.error.empty"))
                    .test("format", i18nUtils.get("onboarding.step.verifyEmail.email.error.invalidFormat"), (value) =>
                        validateEmailWithRegex(value),
                    ),
            }),
        onSubmit: (data) => {
            setEmail(data.email);
            sendCode(data.email, false);
        },
    };

    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            code: "",
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
        },
        validationSchema: () =>
            Yup.object()
                .shape({
                    code: Yup.string(),
                    code1: Yup.string(),
                    code2: Yup.string(),
                    code3: Yup.string(),
                    code4: Yup.string(),
                    code5: Yup.string(),
                })
                .test("errors", " ", (values) => {
                    const { code, code1, code2, code3, code4, code5 } = values;
                    if (!code || !code1 || !code2 || !code3 || !code4 || !code5) {
                        return false;
                    }
                    return true;
                }),
        onSubmit: (event, data) => {
            const { code, code1, code2, code3, code4, code5 } = data;
            const fullCode = `${code}${code1}${code2}${code3}${code4}${code5}`;
            setIsValidating(true);
            dispatch(onboardingActions.verifyCodeReceive(fullCode, "email", email, "", exchangeToken));
        },
    };

    const getSubtitle = () => {
        const params = { 0: "6", 1: email };
        return i18nUtils.get("onboarding.step.verifyEmail.modal.subtitle", null, params);
    };

    const handleStopTimer = (e) => {
        // chequea que el click no sea desde el input o que no sea desde los botones
        if (e.target.localName !== "input" && e.target.parentElement.id === "") {
            clearTimeout(timerRef.current);
            dispatch(modalActions.modalClose());
        }
    };

    const handleSendCode = (e) => {
        sendCode(email, true);
        e.stopPropagation();
    };

    const handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        formikPropsParam.onSubmit(event, data);
    };

    const createValidateEmailBodyModal = () => (
        <>
            <Formik {...formikValidateProps}>
                {(allFormik) => (
                    <Form noValidate>
                        <GridTable className="token-code-fields">
                            <GridTable.Container>
                                <GridTable.Data>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code"
                                        id="code"
                                        hideLabel
                                        onKeyUp={(e) => {
                                            onFocus("code1", e.target.value);
                                        }}
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code1"
                                        id="code1"
                                        onKeyUp={(e) => {
                                            onFocus("code2", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code", e.code || e.key, null, null, allFormik.values.code1);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code3", e.target.value);
                                        }}
                                        name="code2"
                                        id="code2"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code1", e.code || e.key, null, null, allFormik.values.code2);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code4", e.target.value);
                                        }}
                                        name="code3"
                                        id="code3"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code2", e.code || e.key, null, null, allFormik.values.code3);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code4"
                                        id="code4"
                                        onKeyUp={(e) => {
                                            onFocus("code5", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code3", e.code || e.key, null, null, allFormik.values.code4);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code5"
                                        id="code5"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown(
                                                "code4",
                                                e.code || e.key,
                                                "code5",
                                                allFormik.setFieldValue,
                                                allFormik.values.code5,
                                            );
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                        {Object.keys(allFormik.errors).length > 0 && (
                            <div className="error">{allFormik.errors[Object.keys(allFormik.errors)[0]]}</div>
                        )}
                        <Button
                            bsStyle="link"
                            label="onboarding.step.verifyEmail.modal.resendcode.action"
                            loading={false}
                            onClick={handleSendCode}
                            disabled={!resendAvailable}
                            id="save-code-button"
                        />

                        <div className="form-actions">
                            <Button
                                bsStyle="primary"
                                label="onboarding.step.verifyEmail.modal.button.validate"
                                loading={false}
                                onClick={(ev) => handleOnSubmit(formikValidateProps, ev, allFormik.values)}
                                block
                                disabled={!(allFormik.isValid && allFormik.dirty)}
                                id="submit-button"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );

    const onhandleClickAlert = () => {
        dispatch(alertActions.alertClose());
    };

    const createAlertBodyModal = () => <ErrorPopup error={error} handleClick={onhandleClickAlert} />;
    if (validateError) {
        return (
            <>
                {isMobile && (
                    <ResponsiveHeader
                        ticket
                        id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onClickBack={isMobile && onHeaderBack}
                    />
                )}
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head
                                    title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                                    onBack={isMobile && onHeaderBack}
                                />
                            </Col>
                        </Container>
                    )}

                    <div>
                        <Col xs={12} md={8} mdOffset={2}>
                            <h1 className="text-center">
                                <CustomText text={i18nUtils.get("", title)} />
                            </h1>
                        </Col>
                        <div className="illustration text-center">
                            <Image src="figma/illustrations/onboarding14.svg" className="svg-image logo" />
                        </div>
                        {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                        <div className="box box-border-soft">
                            {" "}
                            <CustomText text={i18nUtils.get("", error)} />
                            {error2 !== "" ? (
                                <>
                                    <br />
                                    <br />
                                    <CustomText text={i18nUtils.get("", error2)} />
                                </>
                            ) : null}
                        </div>

                        <div className="form-actions">
                            <Button
                                bsStyle="primary"
                                label="global.agreed"
                                loading={false}
                                onClick={() => {
                                    setvalidateError(false);
                                    dispatch(modalActions.modalClose());
                                }}
                            />
                        </div>
                    </div>
                </MainContainer>
            </>
        );
    }
    return (
        <>
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                <Stepper isMobile={isMobile} page={pageId} />
                {!isMobile && (
                    <Head
                        title={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                        onBack={isMobile && onHeaderBack}
                    />
                )}

                {displayModal && (
                    <InfoModal
                        noAcceptButton
                        noCancelButton
                        bodyInfoText="texto"
                        modalSubtitle={getSubtitle()}
                        useScroll
                        body={createValidateEmailBodyModal}
                        onClick={handleStopTimer}
                    />
                )}
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <CustomText text={i18nUtils.get("", "Validá tu email")} />
                </h1>
                <CustomText text={i18nUtils.get("", "Ingresá un email personal al que puedas acceder.")} />
                <Formik {...formikProps}>
                    {(allFormik) => (
                        <Form className="above-the-fold" noValidate>
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={50}
                                name="email"
                                type="email"
                                autoFocus={!isMobile}
                            />
                            <div className="form-actions">
                                <Button
                                    bsStyle="primary"
                                    label="global.continue"
                                    type="submit"
                                    block
                                    disabled={!(allFormik.isValid && allFormik.dirty)}
                                    loading={!!isValidating}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>

            {displayAlert && (
                <InfoModal noAcceptButton noCancelButton bodyInfoText="texto" useScroll body={createAlertBodyModal} />
            )}
        </>
    );
};

StepEmail.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
    exchangeToken: string.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
    displayModal: bool,
    displayAlert: bool,
    verifyCode: shape({}),
    business: shape({}),
};

StepEmail.defaultProps = {
    displayModal: false,
    displayAlert: false,
    verifyCode: {},
    business: {},
};

const mapStateToProps = (state) => ({
    displayModal: modalselectors.getDisplayModal(state),
    verifyCode: onboardingSelectors.getVerifyCode(state),
    displayAlert: alertselectors.getDisplayAlert(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    business: onboardingSelectors.getBusiness(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepEmail);
